export enum StatusChange {
	NO_CHANGE,
	UPGRADE,
	DOWNGRADE
};

export enum GranularStatusChange {
	GREEN_YELLOW = 'greenYellow',
	YELLOW_RED = 'yellowRed',
	GREEN_RED = 'greenRed'
};

export enum StatusChangeType {
	upgradedFunds = 'upgradedFunds',
	downgradedFunds = 'downgradedFunds'
}
